import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'shrd-uic-form-button',
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormButtonComponent implements OnChanges {
  @Input() selected? = false;
  @Input() disabled? = false;
  @Input() ariaLabelSelected?: string;
  @Input() ariaLabelUnselected?: string;
  @Input() qaId?: string;
  @Input() type: 'checkbox' | 'radio';
  @Input() trackingEvent? = 'default';
  @Input() trackingCategory?: string;
  @Input() trackingAction?: string;
  @Input() trackingLabel?: string;
  @Input() omitInitialTracking = true;

  @Output() checkedChange = new EventEmitter<boolean>();

  // Button reference is public for use in flyout-option.component for accessible keyboard navigation
  @ViewChild('button') public button: ElementRef;

  ariaLabel: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selected']) {
      this.ariaLabel = this.selected ? this.ariaLabelSelected : this.ariaLabelUnselected;
    }
  }

  /**
   * called upon interaction with the button
   */
  buttonToggle(): void {
    if (!this.disabled && !(this.type === 'radio' && this.selected)) {
      this.selected = !this.selected;
      this.checkedChange.emit(this.selected);
    }
  }
}
